import { render, staticRenderFns } from "./MaterialSelector.vue?vue&type=template&id=487ae5ba&scoped=true&"
import script from "./MaterialSelector.vue?vue&type=script&lang=js&"
export * from "./MaterialSelector.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSelector.vue?vue&type=style&index=0&id=487ae5ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ae5ba",
  null
  
)

export default component.exports